(() => {
  const KEY = "purchase_origin";

  const container = document.querySelector(".js-cooperative-origin-selector");
  if (!container) return;

  const selected = container.dataset.selected || "";

  const updateCartOrigin = async (origin) => {
    if (!origin) return;

    container.style.pointerEvents = "none";
    container.style.opacity = "0.6";

    try {
      sessionStorage.setItem(KEY, origin);

      const cartResponse = await fetch("/cart.js", {
        headers: { Accept: "application/json" },
      });

      const cart = await cartResponse.json();

      const itemsWithOrigin = cart.items
        .map((item, index) => ({ item, line: index + 1 }))
        .filter(({ item }) => item.properties && item.properties._origin);

      for (const { item, line } of itemsWithOrigin) {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            line,
            quantity: item.quantity,
            properties: {
              ...item.properties,
              _origin: origin,
            },
          }),
        });
      }

      window.location.reload();
    } catch (error) {
      console.error("Error updating cooperative origin:", error);
      container.style.pointerEvents = "auto";
      container.style.opacity = "1";
    }
  };

  window.createCooperativeSelector({
    container,
    selected,
    onSelect(value) {
      updateCartOrigin(value);
    },
  });
})();